<div class="car-listings-container" dir="rtl">
  <!-- Header -->
  <header class="listings-header">
    <div class="header-content" (click)="navigateToPage()">
      <div class="header-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M5 17h14M5 17a2 2 0 01-2-2V9a2 2 0 012-2h1l2-3h8l2 3h1a2 2 0 012 2v6a2 2 0 01-2 2M5 17a2 2 0 100 4 2 2 0 000-4zM19 17a2 2 0 100 4 2 2 0 000-4z"/>
        </svg>
      </div>
      <div>
        <h2>רכב</h2>
        <!-- Count folded into the subtitle: it's passive information,
        so it belongs with the description rather than occupying
        its own pill alongside the real actions. -->
        <p class="subtitle">
          <span class="subtitle-text">מצא את הרכב המושלם עבורך</span>@if (cars.length) {
          <span
          class="subtitle-count">{{ cars.length }} מודעות</span>
        }
      </p>
    </div>
  </div>
  <div class="header-actions">
    @if (cars.length > 0) {
      <div class="scroll-arrows">
        <button class="arrow-btn" (click)="scrollLeft()" aria-label="מודעות הרכב הבאות">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
        <button class="arrow-btn" (click)="scrollRight()" aria-label="מודעות הרכב הקודמות">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
      </div>
    }
    <button type="button" class="view-all-btn" (click)="navigateToPage()">לכל המודעות</button>
  </div>
</header>

<!-- Loading -->
@if (isLoading) {
  <div class="loading-state">
    <div class="car-loader"><span></span><span></span><span></span></div>
    <p>טוען רכבים...</p>
  </div>
}

<!-- Error -->
@if (error && !isLoading) {
  <div class="error-state">
    <p>אופס! משהו השתבש</p>
    <button (click)="loadCars()" class="retry-btn">נסה שוב</button>
  </div>
}

<!-- Scroll Track -->
@if (!isLoading && !error && cars.length > 0) {
  <div class="scroll-wrapper">
    <div class="car-track" #carTrack dragScroll>
      @for (car of cars; track car; let i = $index) {
        <div
          class="car-card"
          [class.promoted]="isPromoted(car)"
          [style.animation-delay]="i * 60 + 'ms'"
          (click)="openPage(car.id)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'פתיחת מודעת רכב: ' + (car.name || car.CodeProducer || '')"
          (keydown.enter)="openPage(car.id)"
          (keydown.space)="openPage(car.id); $event.preventDefault()"
          >
          <!-- Internal (admin) ad linked to this category — generic layout, -->
          <!-- since it doesn't have any of the car-specific fields below -->
          @if (isInternalAd(car)) {
            <div class="card-image">
              <img
                [src]="car.images[0]?.image || 'https://placehold.co/400x260/e8e4df/8a8580?text=🚗'"
                [alt]="car.name"
                (error)="onImageError($event)"
                />
              <span class="price-tag" [class.no-price]="!car.price">{{ formatPrice(car.price) }}</span>
            </div>
            <div class="card-body">
              <div class="title-row">
                <h3>{{ car.name }}</h3>
              </div>
              @if (car.description) {
                <p class="internal-ad-desc">{{ car.description }}</p>
              }
              @if (car.city) {
                <div class="meta">
                  <span>{{ car.city.nameHe }}</span>
                </div>
              }
              <div class="card-footer">
                <span class="seller">{{ car.userContactDetails?.contactPerson }}</span>
                <app-contact-menu
                  [phone]="car.userContactDetails?.phoneNumber || ''"
                  [itemName]="car.name"
                  [itemId]="car.id"
                  [accentColor]="'#2563eb'"
                ></app-contact-menu>
              </div>
            </div>
          } @else {
            <!-- Image -->
            <div class="card-image">
              <img
                [src]="car.images[0]?.image || 'https://placehold.co/400x260/e8e4df/8a8580?text=🚗'"
                [alt]="car.name"
                (error)="onImageError($event)"
                />
              <span class="price-tag" [class.no-price]="!car.price">{{ formatPrice(car.price) }}</span>
              @if (car.year) {
                <span class="year-tag">{{ car.year }}</span>
              }
              @if (isPromoted(car)) {
                <span class="ads-tag">{{ getAdsBadge(car.adsRoute.level) }}</span>
              }
              <app-card-biz-badges [item]="car"></app-card-biz-badges>
            </div>
            <!-- Body -->
            <div class="card-body">
              <div class="title-row">
                <h3>{{ car.CodeProducer }} {{ car.MainModel || '' }}</h3>
                <span class="cat">{{ car.sconderyCategory.name }}</span>
              </div>
              <div class="meta">
                <span>{{ formatMileage(car.mileage) }}</span>
                <span class="dot"></span>
                @if (car.engineCapacity) {
                  <span>{{ car.engineCapacity }} cc</span>
                }
                @if (car.engineCapacity) {
                  <span class="dot"></span>
                }
                <span>{{ car.NumberOfOwner?.numberOnwer }}</span>
              </div>
              <div class="chips">
                <span class="chip owner">{{ car.CurrentOwner?.Type }}</span>
                @if (car.DrivingTest) {
                  <span class="chip">טסט</span>
                }
                @if (car.exchange) {
                  <span class="chip">חליפין</span>
                }
                @for (arm of car.armatureList.slice(0, 2); track arm) {
                  <span class="chip accent">{{ arm.ArmatureDesc }}</span>
                }
              </div>
              <div class="card-footer">
                <app-card-dealer [item]="car"></app-card-dealer>
                <app-contact-menu
                  [phone]="car.userContactDetails?.phoneNumber || ''"
                  [itemName]="car.name"
                  [itemId]="car.id"
                  [accentColor]="'#2563eb'"
                ></app-contact-menu>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Empty -->
@if (!isLoading && !error && cars.length === 0) {
  <div class="empty-state">
    <p>לא נמצאו רכבים</p>
  </div>
}
</div>
